import qs from "qs";

export const STRAPI_BASE_URL =
  process.env.REACT_APP_STRAPI_ENDPOINT || "http://localhost:1337";
export const STRAPI_CDN_URL =
  process.env.REACT_APP_CDN_URL || "http://localhost:1337/uploads";

export async function getImagenesInicio() {
  try {
    const query = qs.stringify({
      populate: "*",
      sort: ["createdAt:asc"],
    });

    const res = await fetch(`${STRAPI_BASE_URL}/api/plg-imagenes-inicios?${query}`);
    const data = await res.json();

    return data.data || [];
  } catch (err) {
    console.error("Error cargando imágenes de inicio:", err);
    return [];
  }
}

export async function getTarjetasInicio() {
  try {
    const query = qs.stringify({
      populate: "*",
      sort: ["createdAt:asc"],
    });

    const res = await fetch(`${STRAPI_BASE_URL}/api/plg-tarjetas-inicios?${query}`);
    const data = await res.json();

    return data.data || [];
  } catch (err) {
    console.error("Error cargando tarjetas de inicio:", err);
    return [];
  }
}